import React from "react";
import { Route, Routes} from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/style.scss'
import './assets/css/materialdesignicons.min.css'
import IndexBusiness from "./pages/index/index-business";
import WhoWeAre from "./pages/page-who-we-are";
import LicenseInfo from "./pages/page-license-info";
import Nondiscrimination from "./pages/page-statement-of-nondiscrimination";
import FinancialSecurityCalculator from "./pages/page-financial-security-calculator";
import JoinUs from "./pages/page-join-us";
import TermLife from "./pages/page-termlife";
import PermLife from "./pages/page-permlife";
import Budgeting from "./pages/page-budgeting-101";
import Calculators from "./pages/page-financial-calculators";
import LifeInsuranceOwnership from "./pages/page-life-insurance-ownership";
import SupplementalInsurance from "./pages/page-supplemental-insurance";
import Encouragement from "./pages/page-words-of-encouragement";
import Calendly from "./pages/page-calendly";
import TermLife2 from "./pages/page-termlife-copy";
import PermLife2 from "./pages/page-permlife-copy";
import InsuranceBlogHome from "./pages/blog/insurance/page-insurance-blog-home";
import InsuranceBlog1 from "./pages/blog/insurance/page-insurance-blog-1";
import TheLighterSideBlogHome from "./pages/blog/the-lighter-side/page-the-lighter-side-blog-home";
import TheLighterSideBlog1 from "./pages/blog/the-lighter-side/page-the-lighter-side-blog-1";
import RecipesBlogHome from "./pages/blog/recipes/page-recipes-blog-home";
import RecipesBlog1 from "./pages/blog/recipes/page-recipes-blog-1";
import EstatePlanning from "./pages/page-estate-planning";
import Comingsoon from "./pages/spcial/page-comingsoon";
import Maintenance from "./pages/spcial/page-maintenance";
import Error from "./pages/spcial/page-error";

function App() {
  return (
   <>
   <Routes>
     <Route path="/" element={<IndexBusiness/>}/>
     <Route path="/who-we-are" element={<WhoWeAre/>}/>
     <Route path="/license-info" element={<LicenseInfo/>}/>
     <Route path="/financial-calculators" element={<Calculators/>}/>
     <Route path="/statement-of-nondiscrimination" element={<Nondiscrimination/>}/>
     <Route path="/financial-security-calculator" element={<FinancialSecurityCalculator/>}/>
     <Route path="/supplemental-insurance" element={<SupplementalInsurance/>}/>
     <Route path="/join-us" element={<JoinUs/>}/>
     <Route path="/life-insurance-ownership" element={<LifeInsuranceOwnership/>}/>
     <Route path="/term-life" element={<TermLife/>}/>
     <Route path="/perm-life" element={<PermLife/>}/>
     <Route path="/budgeting-101" element={<Budgeting/>}/>
     <Route path="/words-of-encouragement" element={<Encouragement/>}/>
     <Route path="/calendly" element={<Calendly/>}/>
     <Route path="/termlife-copy" element={<TermLife2/>}/>
     <Route path="/permlife-copy" element={<PermLife2/>}/>
     {/*(<Route path="/insurance-blog-home" element={<InsuranceBlogHome/>}/>
     <Route path="/insurance-blog/:id" element={<InsuranceBlog1/>}/>
     <Route path="/the-lighter-side-blog-home" element={<TheLighterSideBlogHome/>}/>
     <Route path="/the-lighter-side-blog/:id" element={<TheLighterSideBlog1/>}/>
     <Route path="/recipes-blog-home" element={<RecipesBlogHome/>}/>
     <Route path="/recipes-blog/:id" element={<RecipesBlog1/>}/>
     <Route path="/recipes-blog/:id" element={<RecipesBlog1/>}/> */}
     <Route path="/estate-planning" element={<EstatePlanning/>}/>  
     <Route path="/page-comingsoon" element={<Comingsoon/>}/>
     <Route path="/page-maintenance" element={<Maintenance/>}/>
     <Route path="/page-error" element={<Error/>}/>
     <Route path="*" element={<Error/>}/>
   </Routes>
   </>
  );
}

export default App;
